import 'bootstrap/dist/css/bootstrap.min.css';
import 'notyf/notyf.min.css'; // for React and Vue

import axios from 'axios';
import useInterval from './Hooks/useInterval';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useParams, NavLink } from 'react-router-dom';
import * as api from './elements/api/api';
import './App.css';
import { useEffect, useRef, useState } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col'; import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import AddClip from './pages/addClip';
import Clips from './pages/clips';
import Notifications from './pages/notifications';
import Playlist from './pages/playlist';
import Login from './pages/Login';
import Player from './pages/Player';
import Bookmarks from './pages/Bookmarks';
import SelectLanguage from './pages/SelectLanguage';
import * as cookies from './elements/api/CookieManagement';
import { Notyf } from 'notyf';
import AddBookmarkForm from './pages/AddBookmarkForm';
import ChannelSubscriptions from './pages/ChannelSubscriptions';
import * as cf from "./elements/api/CoreFunctions"
import * as bm from "./elements/api/BookmarkManagement"



function createSessionFromLocalStorage() {
  return new Promise((resolve) => {
    let uid = cookies.loadFromLocalStorage('uid');
    if (uid == null) {
      resolve(false);
      return;
    }

    api.createSession(uid, success => {
      resolve(success);
    });
  });
}



function CreateSession() {
  let { uid } = useParams();
  api.createSession(uid, success => {
    if (!success) {
      alert("Session was not found. Maybe it is expired. If you use the remember function a new session with empty queue will started.");
    }
    window.location.href = "/clips";

  });
}


function App() {


  const executeAdditionalActions = (rows) => {
    
    rows.map(((row) => {
      if(row.url in addtionalActions && row.status > api.PENDING ){
        if(addtionalActions[row.url][cf.ADDITIONAL_ACTION_ADD_TO_BOOKMARKS]){
          bm.addBookmark(row.url,row.title)
        }
        if(addtionalActions[row.url][cf.ADDITIONAL_ACTION_ADD_TO_PLAYLIST]){
          cf.addClipToPlaylist(playlistElements,setPlaylistElements,row)
        }
        delete addtionalActions[row.url];
      }
    }))
  }
  //Hooks
  const clear = useInterval(() => {
    if (loggedIn && rows != null


      && rows.some((row) => row.status == api.IN_QUEUE | row.status == api.IN_PROGRESS)) {
      api.getJobs((rows) => {

        setRows(rows);

      }
      );
    }
  }, 5000);



  // useEffect(
  //   () => api.getJobs((rows) => {
  //     setRows(rows);
  //   }), []);


  //General
  const [loggedIn, setLoggedIn] = useState(true);
  //Media
  const [showPlayer, setShowPlayer] = useState(false);
  const [showAddClipFromBookmarkForm, setShowAddClipFromBookmarkForm] = useState(false);
  const [bookmarkToAdd, setBookmarkToAdd] = useState(null);
  const [playerSource, setPlayerSource] = useState({});
  const [playerMinimized, setPlayerMinimized] = useState(true);
  const [playlistElements, setPlaylistElements] = useState([]);
  const playlistElementsRef = useRef(playlistElements);
  const [playerCallback, setPlayerCallback] = useState([]);
  const [rows, setRows] = useState([]);
  const rowsRef = useRef(rows);
  //Mail notifaications
  const [sendMailNotification, setSendMailNotification] = useState(false);
  const [mail, setMail] = useState(cookies.getCookie("mail"));
  const [selecetedPlaylistIndexState, setSelectedPlaylistIndexState] = useState(-1);
  //Actions
  const [selectLanguageAction, setSelectLanguageAction] = useState(null)
  const [addtionalActions, setAddtionalActions] = useState({})





  let selecetedPlaylistIndex = -1;


  axios.defaults.withCredentials = true;

 const addToAdditionalActions = (url,actions) =>{
  setAddtionalActions({
    ...addtionalActions,
    [url]:actions
  })
  console.log(addtionalActions)
 }

  const selectLanguage = (lang) => {
    const callback = selectLanguageAction[0]
    callback(lang)
    setSelectLanguageAction(null)
  }


  const getMediaItemById = (id) => {
    let row = rowsRef.current.find((item) => item.id === id);
    return row;
  }

  const minimizePlayer = () => {
    setPlayerMinimized(true);
  }

  const setSelecetedPlaylistIndex = (index) => {
    selecetedPlaylistIndex = index;
    setSelectedPlaylistIndexState(index);
  }

  const selectPlaylistItem = (index) => {
    // setSelectedPlaylistIndex(index);
    setSelecetedPlaylistIndex(index);
    playMedia(getMediaItemById(playlistElementsRef.current[index].id), () => playNextPlaylistElement)
  }

  const playNextPlaylistElement = () => {
    let nextIndex = selecetedPlaylistIndex + 1;
    if (nextIndex < playlistElementsRef.current.length) {
      selectPlaylistItem(nextIndex)
    }
    else {
      setSelecetedPlaylistIndex(nextIndex);
    }
  }

  const addClipFromBookmark = (bookmark) => {
    setBookmarkToAdd(bookmark)
    console.log(bookmark)
    setShowAddClipFromBookmarkForm(true)
  }



  const playMedia = (source, callback = () => () => { return; }) => {
    document.title = source.title;
    setPlayerSource(source);
    setShowPlayer(true);
    setPlayerMinimized(false);
    setPlayerCallback(callback);
  }

  useEffect(() => {
    playlistElementsRef.current = playlistElements;
  }, [playlistElements]);

  useEffect(() => {
    rowsRef.current = rows;
    executeAdditionalActions(rowsRef.current)
  }, [rows]);

  const initApp = (uid) => {
    setLoggedIn(true);
    cookies.saveToLocalStorage("uid", uid);
    api.getJobs((rows) => {
      setRows(rows);
      api.cleanMediaBookmarksInLocalStorage(rows);
    })

  }

  useEffect(() => {

    api.checkLogin(res => {
      if (res.logged_in === true) {
        initApp(res.uid);
      }
      else {
        let promise = createSessionFromLocalStorage();
        promise.then((success) => {
          if (success) {
            setLoggedIn(true);
            api.getJobs((rows) => {
              setRows(rows);
              api.cleanMediaBookmarksInLocalStorage(rows);
            })
          }
          else {
            api.checkAutologin(res => {
              if (res.logged_in) {
                initApp(res.uid);
              }
              else {
                setLoggedIn(false)
              }
            })
          }
        })
      }
    })



  }, []);

  const Header = () => {
    return (
      <Navbar expand={loggedIn ? "lg" : undefined} className="bg-body-tertiary">
        <Container>
          <Navbar.Brand >YT-Downloader</Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          {loggedIn &&
            <Navbar.Collapse id="basic-navbar-nav">
              <Nav className="me-auto">
                <NavLink to="/add-clip" className="nav-link">Add Clip</NavLink>
                <NavLink to="/notfications" className="nav-link">Notifications</NavLink>
                <NavLink to="/clips" className="nav-link">Clips</NavLink>
                <NavLink to="/playlist" className="nav-link">Playlist</NavLink>
                <NavLink to="/bookmarks" className="nav-link">Bookmarks</NavLink>
                {/* <NavLink to="/channel-subscriptions" className="nav-link">Channel Subscriptions</NavLink> */}
                {showPlayer && <Nav.Link onClick={() => setPlayerMinimized(false)} href="javascript:;">Player</Nav.Link>}


                {/* <NavDropdown title="Dropdown" id="basic-nav-dropdown">
                    <NavDropdown.Item href="#action/3.1">Action</NavDropdown.Item>
                    <NavDropdown.Item href="#action/3.2">
                      Another action
                    </NavDropdown.Item>
                    <NavDropdown.Item href="#action/3.3">Something</NavDropdown.Item>
                    <NavDropdown.Divider />
                    <NavDropdown.Item href="#action/3.4">
                      Separated link
                    </NavDropdown.Item>
                  </NavDropdown>  */}
              </Nav>


            </Navbar.Collapse>
          }
        </Container>
      </Navbar>
    );
  }

  return (
    <div className="App">
      {/* Show language form */}
      {
        selectLanguageAction!=null &&
        <div>
          <SelectLanguage selectLanguage={selectLanguage} languages={selectLanguageAction[1]} ></SelectLanguage>
        </div>
      }
      {/* Show add bookmark form */}
      {
        showAddClipFromBookmarkForm &&
        <div>
          <AddBookmarkForm addToAdditionalActions={addToAdditionalActions} setShowAddClipFromBookmarkForm={setShowAddClipFromBookmarkForm} rows={rows} setRows={setRows} sendMailNotification={sendMailNotification} mail={mail} bookmark={bookmarkToAdd} openSelectLanguageForm={setSelectLanguageAction} ></AddBookmarkForm>
        </div>
      }
      {showPlayer &&
        <div className={playerMinimized && 'hidden'} >
          <Player rowsRef={rowsRef} callback={playerCallback} source={playerSource} minimizePlayer={minimizePlayer} setShowPlayer={setShowPlayer} />
        </div>
      }
      <Router>
        <Header loggedIn={loggedIn} showPlayer={showPlayer} />
        <Container >
          <Row className="justify-content-md-center">
            <Col className='mt-2'>
              <Routes>
                <Route path='/' element={loggedIn ? <Navigate push to="/add-clip" /> : <Navigate push to="/login" />}></Route>
                <Route path='/login/:uid/' element={<CreateSession />}></Route>
                <Route path='/add-clip' element={loggedIn ? <AddClip addToAdditionalActions={addToAdditionalActions} sendMailNotification={sendMailNotification} mail={mail} rows={rows} setRows={setRows} openSelectLanguageForm={setSelectLanguageAction} /> : <Navigate push to="/" />}></Route>
                <Route path='/clips' element={loggedIn ? <Clips playMedia={playMedia} playlistElements={playlistElements} setPlaylistElements={setPlaylistElements} rows={rows} setRows={setRows} /> : <Navigate push to="/" />}></Route>
                <Route path='/notfications' element={loggedIn ? <Notifications setMail={setMail} mail={mail} setSendMailNotification={setSendMailNotification} sendMailNotification={sendMailNotification} /> : <Navigate push to="/" />}></Route>
                <Route path='/playlist' element={loggedIn ? <Playlist setSelectedIndex={setSelecetedPlaylistIndex} selectedIndex={selecetedPlaylistIndexState} selectPlaylistItem={selectPlaylistItem} playlistElements={playlistElements} setPlaylistElements={setPlaylistElements} /> : <Navigate push to="/" />}></Route>
                <Route path='/login' element={loggedIn ? <Navigate push to="/" /> : <Login setLoggedIn={setLoggedIn} />}></Route>
                <Route path='/bookmarks' element={loggedIn ? <Bookmarks addBookmark={addClipFromBookmark}   /> : <Navigate push to="/" />}></Route>
                {/* <Route path='/channel-subscriptions' element={loggedIn ? <ChannelSubscriptions /> : <Navigate push to="/" />}></Route> */}
              </Routes>
            </Col>
          </Row>
        </Container>
      </Router>

    </div>

  );
}

export default App;
